import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import Skeleton from "react-loading-skeleton";

import { modelOf } from "../../../../prop-types";
import CampaignCode from "../../../campaign-code/CampaignCode";
import CampaignCodeStore from "../../../../store/CampaignCodeStore";
import RequestState from "../../../../types/RequestState";
import CampaignCodeActive from "../../../campaign-code/CampaignCodeActive";

const CheckoutPromoCode = ({ campaignCodeStore }) => {
  useEffect(() => {
    const loadActiveCodes = () => {
      campaignCodeStore.loadActiveCodes()
        .catch((e) => {
          console.error(e);
        });
    }
    loadActiveCodes();
  }, []);

  let promoCode;
  if (campaignCodeStore.state === RequestState.LOADING) {
    promoCode = <Skeleton height={60} width="100%"/>;
  } else {
    promoCode = campaignCodeStore.activeCodes.length === 0
      ? <CampaignCode/> : <CampaignCodeActive shouldPopup={true} />;
  }

  return (
    <div className="CheckoutPromoCode">
      {promoCode}
    </div>
  );
};

CheckoutPromoCode.propTypes = {
  campaignCodeStore: modelOf(CampaignCodeStore).isRequired,
};

export default inject('campaignCodeStore')(observer(CheckoutPromoCode));
